// 页面抽离统一管理
const baseConf = {
  // 基础品牌信息
  name: 'RozCloset',
  companyName: 'INSIGHTCAST PRIVATE LIMITED ',
  address: 'Ground Floor, 67/4696, Abad Bay Pride Tower, High Court Road, Marine Drive, Kochi, Ernakulam, Kerala 682031',
  email: 'support@rozcloset.com',
  
  // 主题配置
  // 2024新色：清新、轻职场、日常通勤取向
  theme: {
    color: '#5cbfa4',      // 柔和通勤绿，主色（Primary/Brand Green, fresh & modern, 高级又轻快）
    secondary: '#a9c2d1',  // 清新雾蓝（次色，搭配灰白，衬托简约之感）
    success: '#5ac86a',     // 明亮清新的青绿
    warning: '#ffd982',     // 柔和淡黄（通勤警示/亮色，耐看不腻）
    danger: '#ef7368',      // 柔雾胭脂红，温和警示
    info: '#49b2e9'         // 轻盈天蓝
  },
  // 定制化配-倾向单独的配置-如首页模块文本色
  custom: {
    // 首页模块介绍文本
    homeIntroduceTitle: '#141312',
    homeIntroduceTitleFont: 'MyriadPro-BoldIt, sans-serif',
    homeIntroduceBg: '#f6f6f6', // 介绍模块背景色
    homeSwiperBg: '#f8f3f4', // 轮播图背景色
    homeNavBtn: '#010101' // 首页导航块按钮色
  },
  // SEO配置
  seo: {
    title: 'RozCloset - Your Fashion Destination',
    description: 'Discover the latest fashion trends at RozCloset. Shop quality clothing and accessories with fast shipping.',
    keywords: 'RozCloset, fashion, clothing, online shopping, trendy clothes'
  },
  // 社交媒体
  social: {
    facebook: 'https://facebook.com/rozcloset',
    instagram: 'https://instagram.com/rozcloset',
    twitter: 'https://twitter.com/rozcloset',
    youtube: 'https://youtube.com/rozcloset'
  },
  
  // 功能开关
  features: {
    enableChat: true,
    enableWishlist: true,
    enableCompare: true,
    enableReviews: true,
    enableNewsletter: true
  }
};

const formatConf = (conf) => {
  const cssVars = {};
  
  // 处理主题配置
  Object.entries(conf.theme).forEach(([key, value]) => {
    // 将驼峰命名转换为中划线命名,例如: primaryColor -> --theme-primary-color
    cssVars[`--theme-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`] = value;
  });
  
  // 处理自定义配置
  Object.entries(conf.custom).forEach(([key, value]) => {
    cssVars[`--tc-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`] = value;
  });
  
  return {
    ...conf,
    cssVars
  };
};

export default formatConf(baseConf);